import { createEntityAdapter } from '@reduxjs/toolkit';

import { AdminSlot } from 'modules/kiosk/types/Slot';
import { ReadySelfService } from 'modules/kiosk/types/GetReadySelfServices';

export const slotsAdapter = createEntityAdapter<AdminSlot>();
export const selfServicesAdapter = createEntityAdapter<ReadySelfService>();
